import { Button, Page, PageEmptyState, PageErrorState, Typography } from 'seagull';
import { CreateProposalButton } from "../CreateProposalButton/CreateProposalButton";
import SeeWhatItsLike from "../SeeWhatItsLike/SeeWhatItsLike";
import EmptyStateIllustartion from "./InvoiceDashboardEmptyStateIllustration.svg";
import img1 from "./SeeWhatItsLikeImages/1.png";
import img2 from "./SeeWhatItsLikeImages/2.png";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const NoInvoices = _ref => {
  let {
    title,
    isVendor
  } = _ref;
  return /*#__PURE__*/_jsx(Page, {
    header: title,
    children: /*#__PURE__*/_jsx(PageEmptyState, {
      "data-testid": "invoices-empty",
      illustration: /*#__PURE__*/_jsx(EmptyStateIllustartion, {}),
      title: "Automatic invoicing is the new standard",
      message: "Invoices are generated automatically according to the agreement\u2019s commercial terms, and your T&Cs.",
      actions: isVendor && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(SeeWhatItsLike, {
          steps: [{
            title: 'We issue your invoice and make sure it gets paid!',
            subtitle: 'Invoices are accessible to you and your client at all times. If action is required by your client, we make sure to remind them, saving you the hassle of being the middleman.',
            image: {
              src: img1,
              width: 1246,
              height: 737
            }
          }, {
            title: 'Getting paid is finally seamless',
            subtitle: /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(Typography, {
                skin: "invertedStandard",
                children: "Invoices are automatically issued and updated with the appropriate status in one convenient place."
              }), /*#__PURE__*/_jsx(Typography, {
                skin: "invertedStandard",
                children: "\uD83D\uDCA1 According to our data, 93.8% of invoices issued on Anchor are paid on the same day!"
              })]
            }),
            image: {
              src: img2,
              width: 1246,
              height: 737
            }
          }],
          "data-testid": "invoices-dashboard"
        }, "see-what-its-like"), /*#__PURE__*/_jsx(CreateProposalButton, {
          hidePrefix: true
        }, "create-proposal-button")]
      })
    })
  });
};
export const NoFilteredInvoices = _ref2 => {
  let {
    resetFilters
  } = _ref2;
  return /*#__PURE__*/_jsx(PageEmptyState, {
    illustration: /*#__PURE__*/_jsx(EmptyStateIllustartion, {}),
    title: "No invoices match your request",
    message: "Try adjusting your search by removing filters.",
    actions: /*#__PURE__*/_jsx(Button, {
      onClick: resetFilters,
      children: "Remove all filters"
    })
  });
};
export const ErrorPage = _ref3 => {
  let {
    retry,
    title
  } = _ref3;
  return /*#__PURE__*/_jsx(PageErrorState, {
    "data-testid": "error-state-page",
    title: title,
    onRefresh: retry
  });
};